import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ShipmentModel } from "features/shared/shipmentCard.types";
import { createBaseSelector, registerSlice } from "shared/lib/redux";

export type CardToDelete = ShipmentModel;

type CardToDeleteState = {
  value: CardToDelete | null;
};

const initialCardToDeleteState: CardToDeleteState = {
  value: null,
};

const cardToDeleteSlice = createSlice({
  name: "CardToDelete",
  initialState: initialCardToDeleteState,
  reducers: {
    setCardToDeleteAction: (state, action: PayloadAction<CardToDelete>) => {
      state.value = action.payload;
    },
    resetCardToDeleteAction: (state) => {
      state.value = null;
    },
  },
});

const cardToDeleteBaseSelector = createBaseSelector(cardToDeleteSlice);

registerSlice([cardToDeleteSlice]);

export const cardToDeleteStore = {
  actions: cardToDeleteSlice.actions,
  selectors: {
    cardToDelete: createSelector(cardToDeleteBaseSelector, (s) => s.value),
  },
};
